module.exports = __webpack_public_path__ + "static/2-0901b2a58873d789a665f7a0a41c0564.jpg";